<div class="relative flex-1 flex flex-col px-base overflow-y-auto">

    <div class="sticky top-0 z-1001 bg-white w-full h-12 pt-base 
        flex justify-between items-start text-viewer-secondary text-lg">
        <div class="flex items-center justify-center gap-x-2">
            <meta-icon icon="school-book"></meta-icon>
            <h1 class="inline-block">{{'Notebook' | translate}}</h1>
        </div>

        <button id="modalClose" class="inline-flex items-center justify-center gap-x-2" (click)="onClose()">
            <p>{{'Close' | translate}}</p>
            <meta-icon icon="close" additionalClasses="text-base"></meta-icon>
        </button>
    </div>

    <div class="ng-star-inserted mt-2 mb-2 pt-2 pb-2 flex items-center justify-end gap-x-2">
        <button class="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-lg"
            [attr.aria-label]="'Create cropping' | translate"
            [attr.title]="'Create cropping' | translate"
            (click)="createClipping.emit(); onClose();"
        >
            <meta-icon icon="crop"></meta-icon>
        </button>

        @if ($pageBookmark()) {
            <button class="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-lg"
                [attr.aria-label]="'Remove from bookmarks' | translate"
                [attr.title]="'Remove from bookmarks' | translate"
                (click)="deleteAnnotation.emit($pageBookmark()); onClose();"
            >
                <meta-icon icon="star-fill"></meta-icon>
            </button>
        } @else {
            <button class="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-lg"
                [attr.aria-label]="'Add to bookmarks' | translate"
                [attr.title]="'Add to bookmarks' | translate"
                (click)="createBookmark.emit(); onClose();"
            >
                <meta-icon icon="star"></meta-icon>
            </button>
        }
    </div>

    @if ($annotations().length > 0) {
        <ul class="flex flex-col pt-2">
            @for (annotation of $annotations(); track $index) {
                <li class="flex items-center px-2 border-t border-t-gray-100 hover:bg-gray-100 gap-x-2">
                    <button type="button" (click)="openAnnotation.emit(annotation); onClose();" [attr.id]="annotation.id"
                        class="flex-1 inline-flex items-center py-3 whitespace-nowrap overflow-hidden gap-x-2">
                        <meta-icon [icon]="annotation.icon" additionalClasses="text-xl" aria-hidden="true"></meta-icon>
                        @if (annotation.type === 'link' || annotation.type === 'note') {
                            <span class="text-lg whitespace-nowrap overflow-hidden overflow-ellipsis hl-underline">
                                {{ (annotation.data?.text || '') | translate }}
                            </span>
                        } @else {
                            <span class="text-lg whitespace-nowrap overflow-hidden overflow-ellipsis {{ annotation.data?.color }}">
                                {{ annotation.title | translate }}
                            </span>
                        }
                    </button>
                    <div class="flex flex-col items-end">
                        <button (click)="deleteAnnotation.emit(annotation); onClose();" [attr.aria-label]="'Remove' | translate">
                            <meta-icon icon="trash" aria-hidden="true"></meta-icon>
                        </button>
                        <span class="text-xs italic">{{ annotation.createdAt | date: 'dd/MM/YYYY' }}</span>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <div class="flex items-center justify-center h-full border-t border-t-gray-300">
            <span class="italic font-light">{{'Workbook is empty' | translate}}</span>
        </div>
    }

</div>

